export default __webpack_public_path__ + "static/media/LandingInfo.845bad15.svg";